'use client'
import React from 'react'
import styles from './styles.module.scss'
import { useTranslations } from 'next-intl'

interface ButtonProps {
  direction: 'prev' | 'next'
  onClick?: () => void
}
const NavigateButton: React.FC<ButtonProps> = props => {
  const { direction } = props
  const t = useTranslations('translation')

  return (
    <button className={styles.button} {...props}>
      {/* eslint-disable-next-line*/}
      <img
        src={
          direction === 'prev'
            ? '/img/games-slider/left-arrow.svg'
            : '/img/games-slider/right-arrow.svg'
        }
        alt={direction === 'prev' ? t('prev') : t('next')}
      />
    </button>
  )
}

export default React.memo(NavigateButton)
